/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateCurrentUserHospitalChatSignature200Response
 */
export interface UpdateCurrentUserHospitalChatSignature200Response {
    /**
     * 
     */
    success?: boolean;
    /**
     * Saved signature (cleaned, single line)
     */
    hospital_chat_signature?: string;
}

/**
 * Check if a given object implements the UpdateCurrentUserHospitalChatSignature200Response interface.
 */
export function instanceOfUpdateCurrentUserHospitalChatSignature200Response(value: object): value is UpdateCurrentUserHospitalChatSignature200Response {
    return true;
}

export function UpdateCurrentUserHospitalChatSignature200ResponseFromJSON(json: any): UpdateCurrentUserHospitalChatSignature200Response {
    return UpdateCurrentUserHospitalChatSignature200ResponseFromJSONTyped(json, false);
}

export function UpdateCurrentUserHospitalChatSignature200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateCurrentUserHospitalChatSignature200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'hospital_chat_signature': json['hospital_chat_signature'] == null ? undefined : json['hospital_chat_signature'],
    };
}

export function UpdateCurrentUserHospitalChatSignature200ResponseToJSON(json: any): UpdateCurrentUserHospitalChatSignature200Response {
    return UpdateCurrentUserHospitalChatSignature200ResponseToJSONTyped(json, false);
}

export function UpdateCurrentUserHospitalChatSignature200ResponseToJSONTyped(value?: UpdateCurrentUserHospitalChatSignature200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'hospital_chat_signature': value['hospital_chat_signature'],
    };
}

